// @ts-nocheck
import React, { useEffect } from 'react';
import { signinRedirectCallback } from '../../services/userService';
import { useNavigate } from 'react-router-dom';

function SigninOidc() {
  const navigate = useNavigate();

  useEffect(() => {
    const logError = (e) => {
      try {
        if (e.message.indexOf('exp is in the past') > -1) {
          const expiryTime = e.message.replace('exp is in the past:', '');
          var tokenExpiresAt = new Date(1970, 0, 1); // Epoch
          tokenExpiresAt.setSeconds(expiryTime);
          const now = new Date();
          console.error(
            `Your browser does not match the server time. Token expires at: ${tokenExpiresAt.toUTCString()}, your time ${now.toUTCString()}`
          );
        }
        console.error(e);
      } catch (ex) {
        console.error(ex);
      }
    };

    async function signinAsync() {
      await signinRedirectCallback()
        .then((user) => {
          navigate(user.state || '/');
        })
        .catch((e) => {
          logError(e);
          navigate('/error');
        });
    }
    signinAsync();
  }, [navigate]);

  return <div>Redirecting...</div>;
}

export default SigninOidc;
